import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonExternalModule } from '../../common/common-external-module';
import { HeaderComponent } from '../../components/header/header.component';
import { LocalStorageService } from '../../services/local-storage.service';
import { ApiFactoryEndPoints } from '../../common/api-factory-end-points';
import { ToastService } from '../../services/toast.service';
import { InvoiceHistoryService } from '../../services/invoice-history.service';
import { MatTableDataSource } from '@angular/material/table';
import { PaymentHistoryDto } from '../../Model/payment-history-dto';
import { GoogleCustomer } from '../../Model/googlecustomer';
import { ProductService } from '../../services/product.service';

@Component({
  selector: 'app-payment-history',
  standalone: true,
  imports: [CommonExternalModule, HeaderComponent],
  templateUrl: './payment-history.component.html',
  styleUrl: './payment-history.component.css'
})
export class PaymentHistoryComponent implements OnInit, OnDestroy {

  googleCustomer: GoogleCustomer;
  dataSource: MatTableDataSource<PaymentHistoryDto>;
  paymentHistory: PaymentHistoryDto[] = [];

  private onViewSubscription: Subscription;

  constructor(
    private localStorage: LocalStorageService,
    private apiFactory: ApiFactoryEndPoints,
    private toastService: ToastService,
    private invoiceHistoryService: InvoiceHistoryService,
    public productService: ProductService
  ) {
    this.dataSource = new MatTableDataSource(this.paymentHistory);
  }

  ngOnInit(): void {
    this.viewWebOrderHistory();
  }

  ngOnDestroy(): void {

  }

  viewWebOrderHistory() {
    this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));
    var customerEmail: string;
    if (this.googleCustomer != null) {
      customerEmail = this.googleCustomer.email;
    }

    this.onViewSubscription = this.invoiceHistoryService.getWebOrderPaymentHistory(this.apiFactory.getWebOrderPaymentHistory, customerEmail, "CAPORD")
      .subscribe((data: any) => {
        console.log(data);
        if (data.length > 0) {
          this.paymentHistory = data;
          this.dataSource.data = this.paymentHistory;
        } else {
          this.toastService.showErrorToast("No Data Available");
        }
      });
  }

  getStatusClass(status: string): string {
    switch (status?.toLowerCase()) {
      case 'success':
        return 'status success';
      case 'aborted':
        return 'status aborted';
      case 'failure':
        return 'status failure';
      default:
        return 'status';
    }
  }
}